var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "icons8_lock_26px_1",
    width: 40,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABmJLR0QA/wD/AP+gvaeTAAACWUlEQVRIDb1Wz2sTURCeeW+3LlYxpkLdUvBHwR48qHjwUvSgYJH+A6KJhUKRnDx4ELQaCgEVvTQHwSJEPHjwKgXBU/UPsIgnpVhUkiIe/EmbJm+c3fjist23uybBZb43M9/Mmy+7L2yCAP92Deau7bOFvEhAZ3jnbgYxaoSwQLJ5r/qgtML5JsNNTAwxlJ8pIOJdbnEYUfYLES59rMzOh4syTJjy4fzMeUD0BtimHua92sSOI8fffnu1+Jrztol2FBMMTxWzhDjHLa0nQLBEIE7LjXrWg1AwDsxx3TMkwrm9k8WMl2hYOoj1TXWO6zsZni1vcdZPLN+/9dVL/uDZYO7ySwu3LnE+whhogMqxLzN8S3VHivyD9zfwGdwMifj86qM7PxHotp/wQorG2bUtlRAAHtY7NprquY7DXkj5t4Z4KFhPJcQHk9Wbdq1Zn3Qc9n39X4K1gWA9lRBv6GP49uZJse4HEcu7cnk9QDuB+P+F/FSixY5OT9vVNXeWD/gsIOyJ7kpgCVYI8LHrVK9LUysenCgh0hUWyZh6EnmEDH9Lx340t1nGM2KRC4mD0jdMGoV4hsvolblxQr0S8ed0IURPG0rtl1KMANGCPy1mSfeuixhAQhVWH5Y+eCV36mpBNOR7iLk6viNFttRzVR0T5yQ26GFhL6k5rzlLiHasubDvWIhftKcCw04G4siwC6HIeUbSMlZSFIbyxTGJwD+wKrG7KyFE9SJZovUZjI+OAGqtlp6sVaMQEFagd1dFmmYdODa6+L2x3ea37yj39DM6sc/8j6jsOrUbvwFb3pJ1904TMQAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock_icon.4535ad7dba3f89a12e93e4a2dadcdce1.svg";
export { ForwardRef as ReactComponent };